import React from "react";
import logoImage from "../assets/astoria-logo.png";

/**
 * Astoria Solutions logo — uses the user-provided image asset (transparent).
 */
export const LogoMark = ({ size = 44, className = "" }) => (
  <img
    src={logoImage}
    alt="Astoria Solutions"
    className={className}
    style={{
      height: size,
      width: "auto",
      objectFit: "contain",
      display: "block",
      filter: "contrast(1.08) saturate(1.15)",
    }}
  />
);

/**
 * Full logo. Since the mark already includes the "ASTORIA" wordmark, only a
 * subtle "SOLUTIONS" caption is shown alongside it.
 */
const Logo = ({ variant = "dark", showCaption = true }) => {
  const subClass = variant === "dark" ? "text-neutral-500" : "text-neutral-300";
  return (
    <div className="flex flex-col items-center">
      <LogoMark size={52} />
      {showCaption && (
        <span
          className={`${subClass} mt-1`}
          style={{
            fontFamily: "'Inter', system-ui, sans-serif",
            fontWeight: 600,
            fontSize: "0.62rem",
            letterSpacing: "0.42em",
          }}
        >
          SOLUTIONS
        </span>
      )}
    </div>
  );
};

export default Logo;
